import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {ErrorContext} from "../../../../components/GympinPagesProvider";
import __placeListItemSlick from "../../../places/placesList/__placeListItemSlick";
import {gym_query} from "../../../../network/api/gym.api";
import Slick from "react-slick";
import {CircularProgress, Grid2 as Grid} from "@mui/material";

const _epCarouselGymList = ({carousel}) => {

    const navigate = useNavigate();
    const error = useContext(ErrorContext);
    const [places, setPlaces] = useState(null);


    useEffect(() => {
        getPlaces();
    }, []);





    function getPlaces(){
        gym_query({...JSON.parse(carousel.Items?.[0]?.Data)}).then(result => {
            setPlaces(result.data.Data);
        }).catch(e => {
            try {
                error.showError({message: e.response.data.Message});
            } catch (f) {
                error.showError({message: "خطا نا مشخص",});
            }
        });
    };
    return (
        <>
            {places&&carousel&&<Slick {...JSON.parse(carousel?.Data)}>
                {[...places?.content,...places?.content,...places?.content]?.map((item, index) => (<__placeListItemSlick item={item}/>))}
            </Slick>}
            {!places&&
            <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", height: "150px" }}>
                <CircularProgress />
            </Grid>}
        </>
    );
};

export default _epCarouselGymList;
